import { render } from "./MovieCard.vue?vue&type=template&id=15cb7d6c&scoped=true"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"

import "./MovieCard.vue?vue&type=style&index=0&id=15cb7d6c&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cb7d6c"]])

export default __exports__